import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/es/index';
import 'core-js/stable';

import React from 'react';
import { BrowserRouter, Route } from "react-router-dom";

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './reducers';
import * as serviceWorker from './serviceWorker';

// Assets
// ==========================================
//
// Assets: JS
import 'bootstrap/dist/js/bootstrap.bundle';

// Assets: Stylesheets
import './assets/vendors/fonts.scss';
import './assets/vendors/bootstrap.scss';

// Components
// ==========================================
//
// Components: Utils
// import history from './utils/history';

// Components: Local
import App from './app/index';
import { URLParams, urlQueries } from './constants/utils/urlParams';

const container = document.getElementById('root');
const root = createRoot(container);
URLParams.register(urlQueries);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <div className="sbx-scroller"><div className="line"></div></div>
                <Route path="/" component={App} />
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
